// @flow
import React, { type Node } from 'react';
import cn from 'classnames';

import styles from './ExchangeColumnHeader.module.scss';;


type Props = {
  className?: string,
  title: string,
  description: string,
}

const ExchangeColumnHeader = ({ className, title, description }: Props): Node => {
  return (
    <div className={cn(styles.root, className)}>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
    </div>
  );
};

export default ExchangeColumnHeader;
